export default __webpack_public_path__ + "static/media/carousel2.70dd6441.png";